import React, { FC } from 'react';
import clsx from 'clsx';

import { Heading, Types, RichText, Button, Link } from '@marriott/mi-ui-library';

import { ContentBlockV2Props } from '../SignInContentBlock.types';
import { addSubDirectoryPrefix, TRACKING_CONSTANTS } from '../../../modules/utils';

// Use named rather than default exports.
export const ContentBlockV2: FC<ContentBlockV2Props> = props => {
  const { INTERNAL, JOIN_FOR_FREE, SELECT_ANOTHER_RATE } = TRACKING_CONSTANTS;
  return (
    <div className="text-content-container px-2 px-lg-0">
      {props?.contentBlockHeader && (
        <Heading
          element={Types.tags.h2}
          titleText={props?.contentBlockHeader}
          customClass={props?.contentBlockDescription ? 'mb-2' : 'mb-5'}
          variation={Types.headingType.subtitle}
          fontSize={Types.size.extraLarge}
        />
      )}
      {props?.contentBlockDescription && (
        <RichText
          text={props?.contentBlockDescription ?? ''}
          componentId={'content-block-description'}
          customClass="content-block-description t-font-m point-list mb-4"
        />
      )}
      {props?.joinNowLabel && (
        <div className="">
          <Button
            isLink={true}
            buttonCopy={props?.joinNowLabel}
            target="_self"
            href={props?.joinNowCtaPath}
            custom_click_track_value={`${props?.trackingPageName}|${JOIN_FOR_FREE}|${INTERNAL}|`}
            className={clsx(
              'm-button-m m-button-secondary text-center width-mobile-100 d-flex-sm justify-content-center align-items-center px-4 px-md-3',
              props?.isOverLay ? 'join-now-btn-overlay' : 'join-now-btn',
              'mb-4'
            )}
          />
        </div>
      )}
      {props?.continueAsCTALabel && props?.continueAsCTAPath && (
        <div className="d-flex align-items-center">
          <Link
            target={'_self'}
            linkType="internal"
            text={props?.continueAsCTALabel}
            linkClassName="m-link-back-tertiary-button footer-container__link"
            linkHref={addSubDirectoryPrefix(props?.continueAsCTAPath)}
            {...(props?.hasTrackingPageName
              ? { custom_click_track_value: `${props?.trackingPageName}|${props?.continueAsCTALabel}|${INTERNAL}|` }
              : { custom_click_track_value: '' })}
          />
        </div>
      )}
    </div>
  );
};
